export const localeOptions = [
  {
    title: '繁體中文',
    value: 'tc'
  },
  {
    title: 'English',
    value: 'en'
  }
]
